// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-m_gU","advertDetailService__price":"c-m_gV"};